import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Container, Card, CardBody } from 'reactstrap';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import history from '~/services/history';

import ModalVisualizar from '~/components/ModalMobile/VisualizarPedido';
import { ModalAprovar } from '~/components/Modal/AprovarPedido';
import { LoaderMini } from '~/components/Loaders';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { ExtratoContext } from '~/context/ExtratoContext';
import ReactGA from 'react-ga4';

import Carousel from '../../../../components/Carousel';
// import Banner from '../../../../assets/img/banner/banner.png';

import { MontanteMobile } from './components/MontanteMobile';
import { BotaoGrid } from './components/BotaoGrid';

import { Text } from '../../../../components/Text';
import {
	CardContainer,
	CardContainerLancamento,
	CardLancamentoUnico,
	CardCred,
	CardLancamento,
	Details,
	// ImageBanner,
	ButtonStyle,
	ButtonStyleDetails,
	DetailsLancamento,
	DetailsLancamentoMiddle,
	DetailsLancamentoRight,
} from './styles';

import { PedidoContext } from '../../../../context/PedidoContext';

function DashboardMobile() {
	const { user } = useSelector((state) => state.auth);

	const {
		dataResumo,
		getResumo,
		getPedidos,
		getSolicitacoes,
		aprovarVisualizarSaldo
	} = useContext(PedidoContext);

	const { getSaldo } = useContext(ExtratoContext);

	const [switchButton, setSwitchButton] = useState('');
	const [modalOpen, setModalOpen] = useState(false);

	const [toggleAprovar, setToggleAprovar] = useState(false);

	const [meusLancamentos, setMeusLancamentos] = useState([]);
	const [meusPedidos, setMeusPedidos] = useState([]);
	const [idPedido, setIdPedido] = useState('');
	const [numPedido, setNumPedido] = useState('');
	const [loading, setLoading] = useState(true);

	const [solicitacoes, setSolicitacoes] = useState([]);

	useEffect(() => {
		getSolicitacoes(10, 1, '', '').then(res => {
			res.solicitacoes.map((item) => {
				if (item.status !== 'APROVADO' && item.status !== 'REPROVADO') {
					setSolicitacoes(res.solicitacoes)
				}
			})
			setLoading(false);
		})

		getSaldo(user.dados.documento, '');
		getResumo(10, 1, '', '');

		getPedidos(10, 1, 'enviados', '', 'PENDENTE', '').then(res => {
			setMeusLancamentos(res.data.pedidos);
			setLoading(false);
		});

		getPedidos(5, 1, 'recebidos', '', '', '').then(res => {
			setMeusPedidos(res.data.pedidos);
		});
	}, []);

	function handleClickAutorizarSaldoRevendaGA4() {
		ReactGA.event({
			category: "autorizar_saldo_revenda_click",
			action: "Autorizar Saldo Revenda",
			label: "Autorizando Saldo Revenda",
		});
	}

	return (
		<Container
			style={{
				padding: 0,
				margin: 0,
			}}>
			<MontanteMobile data={dataResumo} />
			<BotaoGrid />
			{/* Aprovação */}
			{user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
				<Card style={{
					marginTop: 18,
					marginLeft: 18,
					marginRight: 18,
					borderRadius: 8,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'center',
				}}>
					{!loading ?
						<CardBody>
							<Text style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '-8px' }}>
								Solicitação de cobrança de Crédito
							</Text>
							{meusLancamentos.length > 0 ?
								meusLancamentos.map((item) => {
									return (
										<CardContainer>
											<CardCred>
												<Details>
													<Text style={{ fontSize: '14px', marginBottom: '8px' }}>{item.nome}</Text>
													<Text style={{ fontWeight: 'bold', fontSize: '18px' }}>{symbolPriceFormatter(item.valor_pedido)}</Text>
												</Details>
												<Details>
													<ButtonStyleDetails
														className="viewDetails"
														type="button"
														onClick={() => {
															setIdPedido(item.id)
															setNumPedido(item.numero_pedido)
															setToggleAprovar(!toggleAprovar)
														}}>
														VER DETALHES
													</ButtonStyleDetails>
												</Details>
											</CardCred>

											<CardCred>
												<ButtonStyle
													className="aprovarCobranca"
													type="button"
													style={{ backgroundColor: color.greenDark }}
													onClick={() => {
														setSwitchButton('aprovar')
														setModalOpen(!modalOpen)
														setNumPedido(item.numero_pedido)
													}}>
													APROVAR COBRANÇA
												</ButtonStyle>

												<ButtonStyle
													className="naoAprovar"
													type="button"
													style={{ color: color.red, backgroundColor: color.redLight }}
													onClick={() => {
														setSwitchButton('nao-aprovar')
														setModalOpen(!modalOpen)
														setNumPedido(item.numero_pedido)
													}}>
													NÃO APROVAR
												</ButtonStyle>
											</CardCred>
										</CardContainer>
									);
								})
								:
								<CardContainer>
									<Text style={{ textAlign: 'center', color: color.grayDark, fontSize: '12px' }}>
										Você não tem solicitações pendentes aqui
									</Text>
								</CardContainer>
							}
						</CardBody>
						:
						<LoaderMini />
					}
				</Card>
			}

			{/* Permissão */}
			{user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
				<Card style={{
					marginTop: 18,
					marginLeft: 18,
					marginRight: 18,
					borderRadius: 8,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'center',
				}}>
					{!loading ?
						<CardBody>
							<Text style={{ fontWeight: 'bold', fontSize: '12px' }}>
								Solicitação de visualização de Crédito
							</Text>
							{solicitacoes.length > 0 ?
								solicitacoes.map((item) => {
									return (
										<CardContainer>
											<Details>
												<Text style={{ fontSize: '14px' }}>{item.nome}</Text>
											</Details>

											<CardCred>
												<ButtonStyle
													className="novoPedido"
													type="button"
													style={{ backgroundColor: color.greenDark }}
													onClick={() => {
														aprovarVisualizarSaldo(item.id, 'APROVADO').then(() => {
															getSolicitacoes(10, 1, '', '')
														})
													}}>
													PERMITIR
												</ButtonStyle>

												<ButtonStyle
													className="novoPedido"
													type="button"
													style={{ color: color.red, backgroundColor: color.redLight }}
													onClick={() => {
														aprovarVisualizarSaldo(item.id, 'REPROVADO').then(() =>
															getSolicitacoes(10, 1, '', '')
														)
														handleClickAutorizarSaldoRevendaGA4();
													}}>
													NÃO PERMITIR
												</ButtonStyle>
											</CardCred>
										</CardContainer>
									);
								})
								:
								<CardContainer>
									<Text style={{ textAlign: 'center', color: color.grayDark, fontSize: '12px' }}>
										Você não tem solicitações pendentes aqui
									</Text>
								</CardContainer>
							}
						</CardBody>
						:
						<LoaderMini />
					}
				</Card>
			}
			{/* Histórico */}
			<Card style={{
				marginTop: 18,
				marginLeft: 18,
				marginRight: 18,
				borderRadius: 8,
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
			}}>
				{!loading ?
					<CardBody>
						<Text style={{
							fontWeight: 'bold',
							fontSize: '12px',
							borderBottom: `1px solid ${color.grayMedium}`,
							paddingBottom: '12px'
						}}>
							Últimos Lançamentos
						</Text>
						{meusPedidos.length > 0 ?
							meusPedidos.map((item) => {
								return (
									<CardContainerLancamento>
										<CardLancamento>
											<DetailsLancamento onClick={() => history.push('/client/transacoes')}>
												<Text style={{ fontSize: '14px', paddingBottom: '10px' }}>{item.numero_pedido}</Text>
												<Text style={{ fontSize: '14px', paddingBottom: '10px' }}>{item.nome}</Text>
												<Text style={{ fontSize: '14px', paddingBottom: '10px' }}>
													Ref. Pedido:
													{' '}
													{item.numero_pedido}
												</Text>
											</DetailsLancamento>
											<CardLancamentoUnico>
												<DetailsLancamentoMiddle style={{ paddingRight: '10px' }}>
													<Text style={{ fontSize: '14px', paddingBottom: '10px' }}>{item.status}</Text>
													<Text style={{ fontSize: '14px', paddingBottom: '10px', fontWeight: 'bold' }}>
														{symbolPriceFormatter(item.valor_pedido)}
													</Text>
													<Text style={{ fontSize: '14px', paddingBottom: '10px' }}>
														{moment(item.data_pedido).format(
															'DD/MM/YYYY'
														)}
													</Text>
												</DetailsLancamentoMiddle>
												<DetailsLancamentoRight>
													<ArrowForwardIosIcon />
												</DetailsLancamentoRight>
											</CardLancamentoUnico>
										</CardLancamento>
									</CardContainerLancamento>
								);
							})
							:
							<CardContainer>
								<Text style={{ textAlign: 'center', color: color.grayDark, fontSize: '12px' }}>
									Você não tem solicitações pendentes aqui
								</Text>
							</CardContainer>
						}
					</CardBody>
					:
					<LoaderMini />
				}
			</Card>

			<Card style={{
				backgroundColor: 'transparent',
				marginTop: 18,
				marginLeft: 18,
				marginRight: 18,
				borderRadius: 8,
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
				padding: 0,
			}}>
				<CardBody style={{
					backgroundColor: 'transparent',
					padding: 0,
				}}>
					{/* <ImageBanner src={Banner} alt="Banner Image" style={{ width: '100%' }} /> */}
					<Carousel />
				</CardBody>
			</Card>

			<ModalVisualizar
				user={user}
				setLoading={setLoading}
				numPedido={numPedido}
				idPedido={idPedido}
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
				switchButton={switchButton}
				setMeusPedidos={setMeusLancamentos}
			/>

			<ModalAprovar
				pagina={1}
				filtroData=""
				filtroPesquisa=""
				filtroStatus="PENDENTE"
				setMeusPedidos={setMeusLancamentos}
				user={user}
				idPedido={idPedido}
				numPedido={numPedido}
				setToggle={setToggleAprovar}
				toggle={toggleAprovar}
			/>
		</Container>
	);
}

export default DashboardMobile;
